/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (connectionWebhooks) => ({
    type: actions.CONNECTION_WEBHOOKS_RECEIVE,
    payload: { connectionWebhooks },
});